/**
 * LP Destemperados — Carousel com efeito de escala
 * Usa Embla Carousel (carregado via CDN na seção)
 */
(function () {
  'use strict';

  var TWEEN_FACTOR_BASE = 0.42;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initLpCarousel(emblaNode) {
    var sectionId  = emblaNode.dataset.sectionId;
    var startIndex = parseInt(emblaNode.dataset.startIndex, 10) || 0;

    if (typeof EmblaCarousel === 'undefined') {
      console.warn('LP Destemperados: EmblaCarousel não encontrado.');
      return;
    }

    var viewport = emblaNode.querySelector('.lp-embla__viewport');
    if (!viewport) {
      console.warn('LP Destemperados: .lp-embla__viewport não encontrado.');
      return;
    }

    var embla = EmblaCarousel(viewport, {
      loop: true,
      align: 'center',
      startIndex: startIndex,
      slidesToScroll: 1,
      dragFree: false,
    });

    /* ── Tween Scale ── */
    var tweenNodes = embla.slideNodes().map(function (slideNode) {
      return slideNode.querySelector('.lp-embla__slide__inner');
    });

    function getTweenFactor() {
      return TWEEN_FACTOR_BASE * embla.scrollSnapList().length;
    }

    function applyTweenScale(eventName) {
      var engine         = embla.internalEngine();
      var scrollProgress = embla.scrollProgress();
      var slidesInView   = embla.slidesInView();
      var isScrollEvent  = eventName === 'scroll';
      var tweenFactor    = getTweenFactor();

      embla.scrollSnapList().forEach(function (scrollSnap, snapIndex) {
        var diffToTarget = scrollSnap - scrollProgress;
        var slidesInSnap = engine.slideRegistry[snapIndex];

        slidesInSnap.forEach(function (slideIndex) {
          if (isScrollEvent && slidesInView.indexOf(slideIndex) === -1) return;

          if (engine.options.loop) {
            engine.slideLooper.loopPoints.forEach(function (loopItem) {
              var target = loopItem.target();
              if (slideIndex === loopItem.index && target !== 0) {
                var sign = Math.sign(target);
                if (sign === -1) diffToTarget = scrollSnap - (1 + scrollProgress);
                if (sign === 1)  diffToTarget = scrollSnap + (1 - scrollProgress);
              }
            });
          }

          var tweenValue = 1 - Math.abs(diffToTarget * tweenFactor);
          var scale      = clamp(tweenValue, 0, 1);
          if (tweenNodes[slideIndex]) {
            tweenNodes[slideIndex].style.transform = 'scale(' + scale + ')';
          }
        });
      });
    }

    var slideNodes = embla.slideNodes();

    function updateActiveSlide() {
      var activeIndex = embla.selectedScrollSnap();
      slideNodes.forEach(function (node, i) {
        node.classList.toggle('is-active', i === activeIndex);
      });
    }

    embla.on('reInit',     function () { applyTweenScale('reInit'); });
    embla.on('scroll',     function () { applyTweenScale('scroll'); });
    embla.on('slideFocus', function () { applyTweenScale('slideFocus'); });
    applyTweenScale('init');

    /* ── Botões prev / next ── */
    var wrapper = emblaNode.closest('.lp-carousel-wrapper');
    if (wrapper) {
      var btnPrev = wrapper.querySelector('.lp-carousel-btn--prev');
      var btnNext = wrapper.querySelector('.lp-carousel-btn--next');
      if (btnPrev) btnPrev.addEventListener('click', function () { embla.scrollPrev(); });
      if (btnNext) btnNext.addEventListener('click', function () { embla.scrollNext(); });
    }

    /* ── Dots ── */
    var dotsContainer = document.getElementById('lp-carousel-dots-' + sectionId);
    var dots = dotsContainer ? Array.from(dotsContainer.querySelectorAll('.lp-carousel-dot')) : [];

    function updateDots() {
      var activeIndex = embla.selectedScrollSnap();
      dots.forEach(function (dot, i) {
        var isActive = i === activeIndex;
        dot.classList.toggle('lp-carousel-dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        embla.scrollTo(parseInt(dot.dataset.index, 10));
      });
    });

    /* ── Informações do produto ativo ── */
    var productNameEl = document.getElementById('lp-product-name-' + sectionId);
    var descLeftEl    = document.getElementById('lp-desc-left-'    + sectionId);
    var descRightEl   = document.getElementById('lp-desc-right-'   + sectionId);
    var btnComprar    = document.getElementById('lp-btn-comprar-'   + sectionId);

    function updateProductInfo(animate) {
      var index     = embla.selectedScrollSnap();
      var slideNode = embla.slideNodes()[index];
      var info      = slideNode ? slideNode.querySelector('.lp-slide-info') : null;
      if (!info) return;

      /* Dados do slide ativo */
      var nameEl   = info.querySelector('.lp-slide-info__name');
      var leftEl   = info.querySelector('.lp-slide-info__left');
      var rightEl  = info.querySelector('.lp-slide-info__right');
      var productUrl  = slideNode.dataset.productUrl || '#';
      var variantId   = slideNode.dataset.variantId  || '';
      var btnAction   = slideNode.dataset.btnAction  || 'go_to_product';

      function applyContent() {
        if (nameEl  && productNameEl) productNameEl.textContent = nameEl.textContent.trim();
        if (leftEl  && descLeftEl)    descLeftEl.innerHTML      = leftEl.innerHTML;
        if (rightEl && descRightEl)   descRightEl.innerHTML     = rightEl.innerHTML;

        /* Atualiza o comportamento do botão COMPRAR */
        if (btnComprar) {
          btnComprar.dataset.productUrl = productUrl;
          btnComprar.dataset.variantId  = variantId;
          btnComprar.dataset.btnAction  = btnAction;
        }
      }

      if (!animate) {
        applyContent();
        return;
      }

      if (productNameEl) productNameEl.style.opacity = '0';
      if (descLeftEl)    descLeftEl.closest('.lp-product-info__desc').style.opacity = '0';

      setTimeout(function () {
        applyContent();
        if (productNameEl) productNameEl.style.opacity = '1';
        if (descLeftEl)    descLeftEl.closest('.lp-product-info__desc').style.opacity = '1';
      }, 160);
    }

    /* ── Ação do botão COMPRAR ── */
    if (btnComprar) {
      btnComprar.addEventListener('click', function () {
        var action    = btnComprar.dataset.btnAction   || 'go_to_product';
        var productUrl = btnComprar.dataset.productUrl || '#';
        var variantId  = btnComprar.dataset.variantId  || '';

        if (action === 'add_to_cart' && variantId) {
          btnComprar.classList.add('is-loading');

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            }),
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Erro ao adicionar ao carrinho');
              window.location.href = '/cart';
            })
            .catch(function () {
              /* Fallback: vai para a página do produto */
              window.location.href = productUrl;
            })
            .finally(function () {
              btnComprar.classList.remove('is-loading');
            });
        } else {
          window.location.href = productUrl;
        }
      });
    }

    embla.on('select', function () {
      updateDots();
      updateActiveSlide();
      updateProductInfo(true);
    });

    updateDots();
    updateActiveSlide();
    updateProductInfo(false);
  }

  /* ── Inicializa todos os carousels da LP na página ── */
  function init() {
    document.querySelectorAll('.lp-embla[data-section-id]').forEach(initLpCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
